import { InMemoryCache } from '@apollo/client'

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        bookingsCount: {
          keyArgs: ['data']
        },
        TourPoi: {
          keyArgs: ['id']
        },
        Content: {
          keyArgs: ['id']
        }
      }
    },
    // Prevent tour ids from collapsing counts across different date ranges.
    BookingTourCount: {
      keyFields: false
    }
  }
})
